import { Component, OnInit } from '@angular/core';
import { FileUploadService } from 'src/app/services/file-upload.service';
import { AccountService } from 'src/app/services/account.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-upload-branch-logo',
  templateUrl: './upload-branch-logo.component.html',
  styleUrls: ['./upload-branch-logo.component.css']
})
export class UploadBranchLogoComponent implements OnInit {
  public imagePath;
  imgURL: any;
  public message: string;
  corporates: any = [];
  corporateId: any;
  corporate = 0;
  branchLogo: File;
  branchLogo_loading$: boolean;
  api_success: string;
  api_error: any;
  constructor(private fileuploadService: FileUploadService, private accountService: AccountService,
    private router: Router, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    // this.getCorporates();
  }
  getCorporates() {
    this.accountService.getCorporates()
      .subscribe(data => {
        this.corporates = data;
      });
  }
  onCorporateChange(event) {
    this.corporateId = event.target.value;

  }

  preview(files: FileList) {
    this.message = '';
    if (files.length === 0) {
      return;
    }
    const fileType = files[0].type;
    if (fileType.match(/image\/*/) == null) {
      this.message = 'Only images are supported.';
      return;
    } else {
      this.branchLogo = files.item(0);
      const reader = new FileReader();
      this.imagePath = files;
      reader.readAsDataURL(files[0]);
      reader.onload = (_event) => {
        this.imgURL = reader.result;
      };
    }

  }
  uploadbranchLogo() {
    this.api_error = '';
    this.api_success = '';
    if (this.isValidForm(this.branchLogo, this.corporateId)) {
      this.branchLogo_loading$ = true;
      this.fileuploadService.uploadBranchLogo(this.branchLogo, this.corporateId)
        .subscribe(result => {
          this.branchLogo_loading$ = false;
          if (result === []) {
            this.api_success = 'Branch Logo uploaded successfully';
          } else {
            // this.displayResultInDialog(res);
            this.api_success = result;
          }
        },
          error => {
            this.api_error = error.error;
          }
        );
    } else {
      this.api_error = 'Please fill all required fields';
    }

  }
  goBacktoList() {
    this.router.navigate(['../list'], { relativeTo: this.activatedRoute });
  }
  isValidForm(logo, corporate) {
    if (logo === undefined || logo === null || corporate === 0) {
      return false;
    } else {
      return true;
    }

  }
}
